import { Loader } from '@nv/basic-components'
import { useAdminUserContext, useVoterUserContext } from '@nv/contexts'
import { Redirect } from 'react-router-dom'

export const VerifyUserGuard = ({ component: WrappedComponent, redirectURL = '/' }) => {
  const { adminUser, adminAuthChecked } = useAdminUserContext()
  const { voterUser, voterAuthChecked } = useVoterUserContext()
  if (!adminAuthChecked && !voterAuthChecked) {
    return <Loader />
  } else if ((!adminUser?.username && adminAuthChecked) || (!voterUser?.username && voterAuthChecked)) {
    return <Redirect to={redirectURL} />
  } else {
    return <WrappedComponent />
  }
}
